<template>
    <div class="loading_grid">
        <div class="loading_card" v-for="(item, index) in repeat" :key="index">
            <div class="course_cover_wrap">
                <img class="course_cover" src="@/assets/images/loading_cover.png" />
            </div>
            <div class="course_info">
                <el-skeleton animated/>
            </div>
        </div>
    </div>
</template>

<script>
import { Vue, Component, Prop } from  'vue-property-decorator'

@Component({})
export default class LoadingList extends Vue{
    @Prop({default: 9})
    listLenth

    get repeat(){
        let res = []
        for(let i = 0 ;i < this.listLenth ;i++){
            res.push('')
        }
        return res
    }
}
</script>

<style lang="scss" scoped>
    .loading_grid{
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        grid-template-rows: repeat(auto-fill,15.6rem);
        grid-gap:2.5rem;
    }
    .loading_card{
        text-decoration: none;
        border: solid 2px #FFFFFF;
        overflow: hidden;
        cursor:pointer;
        &:last-child{
            margin-right: 0;
        }
        height: 11.4rem;
        background: #FFFFFF;
        border-radius: 0.4rem;
        padding: 1.9rem;
        display: flex;
        user-select: none;
        .course_cover_wrap{
            width: 20.4rem;
            border-radius: 0.4rem;
            overflow: hidden;
            .course_cover{
                width: 100%;
                height: 100%;
            }
        }
        .course_info{
            flex: 1;
            margin-left: 1.5rem;
        }
    }
</style>